import {
  Box,
  Button,
  Divider,
  Flex,
  Heading,
  HStack,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import axiosInstance from "../../config/axiosInstance";
import CustomDateRangePicker from "../Customer-dashboard/CustomDateRangePicker";
import Header from "../shared/Header";
import AdminGraph from "./AdminGraph";
import AdminStats from "./AdminStats";

const AdminMain = ({ onOpen, SIDEBAR_WIDTH }) => {
  const location = useLocation();
  const isDashboardRoute = location.pathname === "/dashboard";

  const [activeFilter, setActiveFilter] = useState("Last 30 Days");
  const [stats, setStats] = useState([]);
  // const [revenueData, setRevenueData] = useState([]);
  // const [orderTypeData, setOrderTypeData] = useState([]);
  const [dateRange, setDateRange] = useState({
    fromDate: null,
    toDate: null,
  });

  useEffect(() => {
    if (isDashboardRoute) {
      const from = dayjs().subtract(29, "day").toDate();
      const to = new Date();
      setDateRange({ fromDate: from, toDate: to });
      fetchStats(from, to);
    }
  }, [isDashboardRoute]);

  const fetchStats = async (fromDate, toDate) => {
    try {
      const params = {};
      if (fromDate && toDate) {
        params.fromDate = dayjs(fromDate).format("YYYY-MM-DD");
        params.toDate = dayjs(toDate).format("YYYY-MM-DD");
      }

      const res = await axiosInstance.get("/api/orders/stats/admin", { params });
      const data = res.data;

      // ✅ Stats card data
      setStats([
        { label: "Total Orders", value: data.totalOrders || 0 },
        { label: "Total Pending", value: data.totalPending || 0 },
        { label: "Completed", value: data.totalDelivered || 0 },
        { label: "Partial", value: data.totalPartial || 0 },
      ]);

      // ✅ Charts
      // setRevenueData(data.revenueData || []);
      // setOrderTypeData(data.orderTypeData || []);
    } catch (error) {
      console.error("Error fetching admin stats:", error);
    }
  };

  const handleFilterClick = (option) => {
    setActiveFilter(option);
    const today = dayjs();

    if (option === "Today") {
      const date = today.toDate();
      setDateRange({ fromDate: date, toDate: date });
      fetchStats(date, date);
    } else if (option === "Last 7 Days") {
      const from = today.subtract(6, "day").toDate();
      const to = today.toDate();
      setDateRange({ fromDate: from, toDate: to });
      fetchStats(from, to);
    } else if (option === "Last 30 Days") {
      const from = today.subtract(29, "day").toDate();
      const to = today.toDate();
      setDateRange({ fromDate: from, toDate: to });
      fetchStats(from, to);
    } else if (option === "Custom Date") {
      // Keep range empty so user can select
      setDateRange({ fromDate: null, toDate: null });
    }
  };

  const filterOptions = ["Today", "Last 7 Days", "Last 30 Days", "Custom Date"];

  return (
    <Box ml={{ base: 0, md: SIDEBAR_WIDTH }}>
      <Header onSidebarOpen={onOpen} />

      <Box p={4} bg="gray.50" minH="calc(100vh - 64px)">
        {isDashboardRoute ? (
          <>
            {/* Filter Buttons */}
            <Flex
              direction={{ base: "column", md: "row" }}
              justify="space-between"
              align={{ base: "start", md: "center" }}
              gap={4}
              mb={6}
            >
              <Heading size="lg">Dashboard</Heading>
              <HStack spacing={2} flexWrap="wrap">
                {filterOptions.map((option) => (
                  <Button
                    key={option}
                    size="sm"
                    variant={activeFilter === option ? "solid" : "outline"}
                    colorScheme="orange"
                    onClick={() => handleFilterClick(option)}
                  >
                    {option}
                  </Button>
                ))}
              </HStack>
            </Flex>

            {/* ✅ Custom Date Range Picker */}
            {activeFilter === "Custom Date" && (
              <Box mb={8}>
                <CustomDateRangePicker
                  dateRange={dateRange}
                  setDateRange={(newDateRange) => {
                    setDateRange(newDateRange);
                    // Auto-apply filter when dates are selected
                    if (newDateRange.fromDate && newDateRange.toDate) {
                      fetchStats(newDateRange.fromDate, newDateRange.toDate);
                    }
                  }}
                />
              </Box>
            )}

            {/* Stats cards */}
            <AdminStats stats={stats} />

            <Divider my={6} />

            {/* Charts */}
            <AdminGraph fromDate={dateRange.fromDate} toDate={dateRange.toDate} />
          </>
        ) : (
          <Outlet />
        )}
      </Box>
    </Box>
  );
};

export default AdminMain;
